import { render, staticRenderFns } from "./404.vue?vue&type=template&id=4536f99e&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4536f99e",
  null
  
)

export default component.exports